import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "deleteTag",
  tabindex: "-1",
  "aria-labelledby": "deleteTag",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title w-100 text-center fw-bold" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "modal-body content" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-center mb-4" }
const _hoisted_11 = { class: "row py-3 border-top" }
const _hoisted_12 = { class: "col-6 d-flex justify-content-lg-end justify-content-center mb-4 mb-lg-0" }
const _hoisted_13 = { class: "col-6 d-flex justify-content-lg-start justify-content-center" }
const _hoisted_14 = {
  class: "modal fade",
  id: "finishModalDel",
  tabindex: "-1",
  "aria-labelledby": "finishModalDel",
  "aria-hidden": "true"
}
const _hoisted_15 = { class: "modal-dialog" }
const _hoisted_16 = { class: "modal-content" }
const _hoisted_17 = { class: "modal-header" }
const _hoisted_18 = { class: "modal-title w-100 text-center fw-bold" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_20 = { class: "modal-body content border-bottom" }
const _hoisted_21 = {
  key: 0,
  class: "text-center",
  id: "exampleModalLabel"
}
const _hoisted_22 = {
  key: 1,
  class: "text-center",
  id: "exampleModalLabel"
}
const _hoisted_23 = { class: "d-flex justify-content-center py-4" }

import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { Modal } from 'bootstrap'

import Button from '@/components/button/index.vue'
import communityManagerServices from '@/services/community-managers.services'
import { translate } from '@/languages/i18n'
import { USER_MANAGEMENT_STORE } from '@/store/constants'


export default /*#__PURE__*/_defineComponent({
  props: {
  userId: String,
  userName: String,
},
  setup(__props) {

const props = __props

const route = useRoute()
const store = useStore()

const deleteFailed = ref<boolean>(false)
const modalCompleted = ref()



// 2022/09/12 TienNV Fix double click button confirm
const loadingButton = ref(false)
const modalConfirm = ref()

onMounted(() => {
  modalConfirm.value = new Modal(document.getElementById('deleteTag'))
  modalCompleted.value = new Modal(document.getElementById('finishModalDel'))
})
const DeleteUser = async (): Promise<void> => {
  const payload = {
    id: route.params?.id,
    params: {
      page: route.query?.page || '1',
      id: route.query?.id || '',
      name: route.query?.name || '',
      management_no: route.query?.management_no || '',
      full_name: route.query?.full_name || '',
      created_at: route.query?.created_at || '',
      page_of_number: route.query?.page_of_number || 30,
    },
  }
  // 2022/09/12 TienNV Fix Failed to delete but successful modal is displayed
  loadingButton.value = true
  try {
    const response = await communityManagerServices.deleteUserManagerFlags(props.userId)
    if (response?.status === 200) {
      store.dispatch(USER_MANAGEMENT_STORE.ACTIONS.SET_USER_FLAG_DATA, payload)
      deleteFailed.value = false
      modalConfirm.value?.hide()
      modalCompleted.value?.show()
      setTimeout(() => {
        loadingButton.value = false
      }, 2000)
      return
    }
    deleteFailed.value = true
    modalConfirm.value?.hide()
    modalCompleted.value?.show()
    setTimeout(() => {
      loadingButton.value = false
    }, 2000)
  } catch (error) {
    console.log(error)
    deleteFailed.value = true
    modalConfirm.value?.hide()
    modalCompleted.value?.show()
    loadingButton.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('CN51titleConfirm')), 1),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(translate)('CN10textDel1')) + "「" + _toDisplayString(__props.userName) + "」" + _toDisplayString(_unref(translate)('CN10textDel4')), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(translate)('CN10textDel2')), 1),
            _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(translate)('CN10textDel3')), 1),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(Button, {
                  title: _unref(translate)('cancel'),
                  class: "m-w-unset",
                  type: 'secondary',
                  "data-bs-dismiss": "modal"
                }, null, 8, ["title"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(Button, {
                  title: _unref(translate)('deleteButton'),
                  class: "m-w-unset",
                  type: 'secondary',
                  onClick: DeleteUser,
                  loading: loadingButton.value,
                  disabled: loadingButton.value
                }, null, 8, ["title", "loading", "disabled"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("h5", _hoisted_18, _toDisplayString(_unref(translate)('CN51titleConfirm')), 1),
            _hoisted_19
          ]),
          _createElementVNode("div", _hoisted_20, [
            (!deleteFailed.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_unref(translate)('CN10textDel1')) + "「" + _toDisplayString(__props.userName) + "」" + _toDisplayString(_unref(translate)('CN10afterDeleted')), 1))
              : _createCommentVNode("", true),
            (deleteFailed.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_unref(translate)('CC10errorDeleted')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              size: 'small',
              "data-bs-dismiss": "modal"
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})